import { useGroup } from '@/react/portainer/environments/environment-groups/queries/useGroup';
import { EnvironmentGroupId } from '@/react/portainer/environments/types';
import { useTeams } from '@/react/portainer/users/teams/queries/useTeams';

import { FormControl } from '@@/form-components/FormControl';

interface Props {
  groupId: EnvironmentGroupId;
}

/** Lists the policies and team access that environments in the group inherit. */
export function GroupInheritance({ groupId }: Props) {
  const groupQuery = useGroup(groupId);
  const teamsQuery = useTeams();

  const group = groupQuery.data;
  if (!group || !teamsQuery.data) {
    return null;
  }

  const policies = group.Policies.map((policy) => policy.Name);
  const teamIds = Object.keys(group.TeamAccessPolicies ?? {}).map(Number);
  const teams = teamsQuery.data
    .filter((team) => teamIds.includes(team.Id))
    .map((team) => team.Name);

  return (
    <FormControl label="Inherits" dataCy="group-inheritance">
      <dl className="mb-0 grid grid-cols-[max-content_1fr] gap-x-4 gap-y-1 pt-[7px]">
        <dt className="text-muted font-normal">Policies</dt>
        <dd className="mb-0">{policies.join(', ') || 'None'}</dd>
        <dt className="text-muted font-normal">Team access</dt>
        <dd className="mb-0">{teams.join(', ') || 'None'}</dd>
      </dl>
    </FormControl>
  );
}
